import { render, staticRenderFns } from "./single-event-record.vue?vue&type=template&id=0dbe08b4&scoped=true"
import script from "./single-event-record.vue?vue&type=script&lang=js"
export * from "./single-event-record.vue?vue&type=script&lang=js"
import style0 from "./single-event-record.vue?vue&type=style&index=0&id=0dbe08b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbe08b4",
  null
  
)

export default component.exports